unit Reports.Summary.Utils;

interface

uses
  SysUtils;

type
  TSummaryReportUtils = class
  public
    [Async]
    class procedure SummaryReport(const AGroupByField: string;
      const AStartDate, AEndDate: TDate; const ADateField: string); async;
  end;

implementation

uses
  XData.Web.Client,
  MainDataModule,
  JS,
  Reports.Result.Utils;

{ TSummaryReportUtils }

class procedure TSummaryReportUtils.SummaryReport(const AGroupByField: string;
  const AStartDate, AEndDate: TDate; const ADateField: string); {$IFDEF PAS2JS}async;{$ENDIF}
var
  lRetval: TXDataClientResponse;
begin
  lRetval := Await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('ISummaryReportsService.SummaryReport',
    [AGroupByField, AStartDate, AEndDate, ADateField]));

  TReportResultUtils.HandleReportResult(TJSObject(lRetval.Result));
end;

end.
